/**
 * SummaryCard Component
 * 
 * Displays a summary metric card (e.g., Call Counts, Duration, Latency)
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {string} props.title - Card title
 * @param {string|number} props.value - Main value to display
 * @param {string} [props.subtitle] - Optional subtitle
 * @param {React.ReactNode} [props.icon] - Optional icon
 */
const SummaryCard = ({ title, value, subtitle, icon }) => {
  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700 p-6 hover:border-gray-600 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            {icon && <div className="text-[#3AD0E6]">{icon}</div>}
            <p className="text-sm text-gray-400">{title}</p>
          </div>
          <p className="text-3xl font-semibold text-white mt-2">
            {value || '—'}
          </p>
          {subtitle && (
            <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitle: PropTypes.string,
  icon: PropTypes.node
};

export default SummaryCard;

